module.exports = __webpack_public_path__ + "img/pulled_pork_ovn.8507f90d.jpg";